import request from './request'

// 对大咖点赞
export function zanDaka(teacher) {
  const url = '/user_behavior/like'
  return request.get(url, {
    params: {
      type: 'user',
      teacher_id: teacher
    }
  })
}

// 对视频点赞
export function zanVideo(courseId, videoId) {
  const url = '/user_behavior/like'
  return request.get(url, {
    params: {
      type: 'video',
      course_id: courseId,
      video_id: videoId
    }
  })
}

// 对评论点赞
export function zanComment(commentId) {
  const url = '/user_behavior/like'
  return request.get(url, {
    params: {
      type: 'comment',
      comment_id: commentId
    }
  })
}

// 分享渠道的类型的常量
export const ChannelHaoYou = 4
export const ChannelPengYouQuan = 3

// 分享统计: 统计大咖详情页分享
export function dakaShare(uid, channel) {
  // uid 分享哪个大咖 , 渠道 微信好友 或者 朋友圈
  const url = '/user_behavior/share'
  return request.get(url, {
    params: {
      type: 'user',
      share_user_id: uid,
      channel: channel
    }
  })
}

// 分享统计: 统计视频播放页的分享
export function videoPageShare(courseId, videoId, channel) {
  // uid 分享哪个大咖 , 渠道 微信好友 或者 朋友圈
  const url = '/user_behavior/share'
  return request.get(url, {
    params: {
      type: 'video',
      video_id: videoId,
      course_id: courseId,
      channel: channel
    }
  })
}

// 分享统计: 统计体系课详情页的分享
export function coursePageShare(courseId, videoId, channel) {
  // uid 分享哪个大咖 , 渠道 微信好友 或者 朋友圈
  const url = '/user_behavior/share'
  return request.get(url, {
    params: {
      type: 'course',
      video_id: videoId,
      course_id: courseId,
      channel: channel
    }
  })
}

// 关注大咖
export function followDaka(teacher) {
  const url = '/teacher/follow'
  return request.get(url, {
    params: {
      teacher_id: teacher
    }
  })
}

// 取消关注大咖
export function unfollowDaka(teacher) {
  const url = '/teacher/unfollow'
  return request.get(url, {
    params: {
      teacher_id: teacher
    }
  })
}

// 收藏课程 微课 或者 体系课
export function collectCourse(courseId, videoId) {
  const url = '/user_behavior/collection'
  return request.get(url, {
    params: {
      type: 'course',
      course_id: courseId,
      video_id: videoId
    }
  })
}


// WEBPACK FOOTER //
// ./src/api/user-behavior.js